import { React, withRouter, PT } from '@gasbuddy/react';
import moment from 'moment';
import JSONTree from 'react-json-tree';
import { Table, Popup } from 'semantic-ui-react';

function desc(audit) {
  if (audit.event === 'wex-decline' && audit.extra_data) {
    return `wex-decline:${audit.extra_data.reason}`;
  }
  return audit.event;
}

const BaseAuditTable = ({ audit }) => (
  <Table basic="very" selectable style={{ tableLayout: 'fixed', fontSize: '0.9em' }}>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Date</Table.HeaderCell>
        <Table.HeaderCell>Provider</Table.HeaderCell>
        <Table.HeaderCell>Event</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {audit.map(a => (
        <Popup
          wide="very"
          on="click"
          trigger={(
            <Table.Row key={a.audit_id}>
              <Table.Cell>{moment(a.created).format('M/DD/YY HH:mm')}</Table.Cell>
              <Table.Cell>{a.provider_name}</Table.Cell>
              <Table.Cell>{desc(a)}</Table.Cell>
            </Table.Row>
)}
          content={<JSONTree data={a || {}} />}
        />
      ))}
    </Table.Body>
  </Table>
);

BaseAuditTable.propTypes = {
  audit: PT.arrayOf(PT.shape({
    provider_name: PT.string.isRequired,
    created: PT.string.isRequired,
    event: PT.string.isRequired,
  })),
};

BaseAuditTable.defaultProps = {
  audit: [],
};

export const AuditTable = withRouter(BaseAuditTable);
